import styled from "styled-components";

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  justify-content: center;
  margin: 0 auto;
  width: fit-content;

  header {
    border-bottom: 1px solid rgba(218, 222, 229, 0.3);
    color: #fff;
    font-size: 19px;
    padding: 7px 0;
    text-align: center;
  }
`;

export default StyledContainer;
